import Axios from "axios";
import { INVITED_BASE_URL } from "../common";

const appEnv = process.env.APP_ENV;

const axios = Axios.create({
  baseURL: `${INVITED_BASE_URL}/api/room`,
  withCredentials: appEnv === "prod" || appEnv === "staging" ? false : true,
});

interface CreateRoomResponse {
  invite_id: string;
}

const createRoom = () =>
  axios.post<CreateRoomResponse>("/", { use_vanity: false });

const closeRoom = () => axios.delete("/");

interface ConnectTokenResponse {
  token: string;
}

const getConnectInfo = (inviteId: string) => {
  return axios.get<ConnectTokenResponse>(`/connect-info?inviteId=${inviteId}`);
};

export default {
  createRoom,
  closeRoom,
  getConnectInfo,
};
